import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import {
  getAuth,
  signInWithEmailAndPassword,
  sendEmailVerification,
} from 'firebase/auth';
import appFirebase from '../Firebase/Firebase';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const auth = getAuth(appFirebase);
const sleep = (ms) => new Promise((res) => setTimeout(res, ms));

const ReenviarVerificaciones = () => {
  const [progress, setProgress] = useState(0);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = async (evt) => {
      setIsLoading(true);
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: 'binary' });
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      const data = XLSX.utils.sheet_to_json(ws, { defval: '' });

      setTotal(data.length);
      let count = 0;

      for (const row of data) {
        const email = row['Correo']?.toString().trim();
        if (!email) continue;

        try {
          const password = 'LaOfi123'; // Contraseña usada en registro masivo
          const credentials = await signInWithEmailAndPassword(auth, email, password);
          const user = credentials.user;

          if (user.emailVerified) {
            console.log(`✅ Ya verificado: ${email}`);
            toast.info(`✅ Ya verificado: ${email}`);
          } else {
            await sendEmailVerification(user);
            console.log(`📨 Verificación enviada: ${email}`);
            toast.success(`📨 Verificación enviada a ${email}`);
          }
        } catch (err) {
          console.error(`❌ Error con ${email}:`, err.message);
          toast.error(`❌ Error con ${email}: ${err.message}`);
        }

        count++;
        setProgress(count);
        await sleep(1000); // pausa entre usuarios
      }

      setIsLoading(false);
      toast.success('🎉 Finalizó el reenvío de verificaciones.');
    };

    reader.readAsBinaryString(file);
  };

  return (
    <div style={{ padding: 20 }}>
      <h3>📨 Reenviar correos de verificación desde Excel</h3>
      <input type="file" accept=".xlsx, .xls" onChange={handleFileUpload} disabled={isLoading} />
      {isLoading && (
        <div style={{ marginTop: 20 }}>
          <p>Procesando: {progress} / {total}</p>
          <div style={{ background: '#ccc', borderRadius: '8px', overflow: 'hidden' }}>
            <div
              style={{
                width: `${(progress / total) * 100}%`,
                height: 20,
                backgroundColor: '#2196f3',
                transition: 'width 0.3s'
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ReenviarVerificaciones;
